/**
 * Protected routes configuration
 * Routes that require authentication
 *
 * Routes can be:
 * - Exact path: "/aura" - matches exactly "/aura"
 * - Path prefix: "/aura" - matches "/aura", "/aura/profile", "/aura/xxx", etc.
 * - Path pattern: "/aura/profile/:id" - matches "/aura/profile/123", etc.
 */
const PROTECTED_ROUTES = ["/aura", "/task"] as const;

/**
 * Notifications screen: /[locale]/[device]/notification → normalized like /app/notification
 */
const NOTIFICATION_ROUTE_PATTERN = /\/notification(\/|$)/;

/**
 * Check if a pathname matches any protected route
 * @param pathname - Current pathname
 * @returns true if the pathname matches a protected route
 */
export const isProtectedRoute = (pathname: string): boolean => {
  const normalizedPath = pathname.replace(/^\/[a-z]{2}\//, "/");

  if (NOTIFICATION_ROUTE_PATTERN.test(normalizedPath)) {
    return true;
  }

  return PROTECTED_ROUTES.some((route) => {
    return normalizedPath === route || normalizedPath.startsWith(`${route}/`);
  });
};
